/* SKT Free Designs Page — v4 (per-design background) */
(function(){
  'use strict';

  var data={categories:[],designs:[],collections:[]};
  try{
    var el=document.getElementById('skt-fdp-data');
    if(el)data=JSON.parse(el.textContent);
  }catch(e){console.warn('[SKT-FDP] data parse failed:',e);}

  var state={activeCatId:'all',searchTerm:'',selectedDesign:null,pickerMode:'collections',activeCollectionHandle:null};

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function escAttr(s){return esc(s);}
  function $(id){return document.getElementById(id);}

  function getCategoryById(catId){
    if(!catId||catId==='all')return null;
    return (data.categories||[]).find(function(c){return c.id===catId;});
  }

  function getDesignsForCategory(catId){
    var all=(data.designs||[]).filter(function(d){return d.image_url;});
    if(catId==='all'||catId==null)return all;
    return all.filter(function(d){return d.category_id===catId;});
  }

  function applySearch(designs,term){
    if(!term)return designs;
    var q=term.toLowerCase().trim();
    if(!q)return designs;
    return designs.filter(function(d){
      var inName=(d.name||'').toLowerCase().indexOf(q)>-1;
      var inTags=(d.tags||[]).some(function(t){return(t||'').toLowerCase().indexOf(q)>-1;});
      var cat=getCategoryById(d.category_id);
      var inCat=cat&&(cat.name||'').toLowerCase().indexOf(q)>-1;
      return inName||inTags||inCat;
    });
  }

  function sortDesigns(designs){
    return designs.slice().sort(function(a,b){
      var so=(a.sort_order||999)-(b.sort_order||999);
      if(so!==0)return so;
      return (a.name||'').localeCompare(b.name||'');
    });
  }

  function renderCategoryStrip(){
    var scroll=$('skt-fdp-cats-scroll');
    if(!scroll)return;
    var cats=(data.categories||[]).slice().sort(function(a,b){return (a.sort_order||999)-(b.sort_order||999);});
    var totalDesigns=(data.designs||[]).filter(function(d){return d.image_url;}).length;
    var allCard='<button type="button" class="skt-fdp__cat-card skt-fdp__cat-card--all'+(state.activeCatId==='all'?' skt-fdp__cat-card--active':'')+'" data-cat-id="all"><span class="skt-fdp__cat-card-emoji">🎨</span><span class="skt-fdp__cat-card-name">All</span><span class="skt-fdp__cat-card-count">'+totalDesigns+' design'+(totalDesigns!==1?'s':'')+'</span></button>';
    var html=allCard;
    cats.forEach(function(c){
      var count=(data.designs||[]).filter(function(d){return d.image_url&&d.category_id===c.id;}).length;
      html+='<button type="button" class="skt-fdp__cat-card'+(state.activeCatId===c.id?' skt-fdp__cat-card--active':'')+'" data-cat-id="'+escAttr(c.id)+'">'+
        '<span class="skt-fdp__cat-card-emoji">'+esc(c.emoji||'🎨')+'</span>'+
        '<span class="skt-fdp__cat-card-name">'+esc(c.name)+'</span>'+
        '<span class="skt-fdp__cat-card-count">'+count+' design'+(count!==1?'s':'')+'</span>'+
      '</button>';
    });
    scroll.innerHTML=html;
  }

  function renderGrid(){
    var grid=$('skt-fdp-grid');
    var empty=$('skt-fdp-empty');
    var title=$('skt-fdp-grid-title');
    var countEl=$('skt-fdp-grid-count');
    if(!grid)return;
    var designs=getDesignsForCategory(state.activeCatId);
    designs=applySearch(designs,state.searchTerm);
    designs=sortDesigns(designs);
    var cat=getCategoryById(state.activeCatId);
    var titleText='All Designs';
    if(state.searchTerm&&state.searchTerm.length>=2){titleText='Search Results';}
    else if(cat){titleText=(cat.emoji?cat.emoji+' ':'')+cat.name+' Designs';}
    if(title)title.textContent=titleText;
    if(countEl)countEl.textContent=designs.length+' design'+(designs.length!==1?'s':'');
    if(designs.length===0){
      grid.innerHTML='';grid.style.display='none';
      if(empty)empty.style.display='block';
      return;
    }
    grid.style.display='';
    if(empty)empty.style.display='none';
    var html='';
    designs.forEach(function(d){
      var thumb=d.image_thumb||d.image_url;
      var c=getCategoryById(d.category_id);
      var catLabel=c?(c.emoji?c.emoji+' ':'')+c.name:'';
      var bgClass=d.dark_background?'skt-fdp__design-img--dark':'skt-fdp__design-img--light';
      html+='<button type="button" class="skt-fdp__design" data-design-id="'+escAttr(d.id)+'">'+
        '<img class="skt-fdp__design-img '+bgClass+'" src="'+escAttr(thumb)+'" alt="'+escAttr(d.name)+'" loading="lazy">'+
        '<div class="skt-fdp__design-body">'+
          '<h3 class="skt-fdp__design-name">'+esc(d.name)+'</h3>'+
          (catLabel?'<p class="skt-fdp__design-cat">'+esc(catLabel)+'</p>':'')+
        '</div>'+
      '</button>';
    });
    grid.innerHTML=html;
  }

  function openPreview(designId){
    var d=(data.designs||[]).find(function(x){return x.id===designId;});
    if(!d)return;
    state.selectedDesign=d;
    var cat=getCategoryById(d.category_id);
    $('skt-fdp-pv-title').textContent=d.name||'Design';
    var imgEl=$('skt-fdp-pv-img');
    imgEl.src=d.image_url||d.image_thumb||'';
    imgEl.alt=d.name||'';
    var pvWrap=$('skt-fdp-pv-img-wrap');
    if(pvWrap){
      pvWrap.classList.remove('skt-fdp-pv-img-wrap--dark','skt-fdp-pv-img-wrap--light');
      pvWrap.classList.add(d.dark_background?'skt-fdp-pv-img-wrap--dark':'skt-fdp-pv-img-wrap--light');
    }
    var metaHtml='';
    if(cat){metaHtml+='<strong>Category</strong>'+esc(cat.emoji||'')+' '+esc(cat.name)+'<br><br>';}
    metaHtml+='<em style="color:#aaa;font-size:12px;">Click "Choose a Shirt" to pick the product you want this design printed on.</em>';
    $('skt-fdp-pv-meta').innerHTML=metaHtml;
    $('skt-fdp-preview').classList.add('active');
    document.body.style.overflow='hidden';
  }

  function closePreview(){
    $('skt-fdp-preview').classList.remove('active');
    document.body.style.overflow='';
    state.selectedDesign=null;
  }

  function openProductPicker(){
    if(!state.selectedDesign)return;
    $('skt-fdp-preview').classList.remove('active');
    state.pickerMode='collections';
    state.activeCollectionHandle=null;
    renderPicker();
    $('skt-fdp-products').classList.add('active');
    document.body.style.overflow='hidden';
  }

  function closeProductPicker(){
    $('skt-fdp-products').classList.remove('active');
    document.body.style.overflow='';
  }

  function backFromPicker(){
    if(state.pickerMode==='products'){
      state.pickerMode='collections';
      state.activeCollectionHandle=null;
      renderPicker();
    } else {
      closeProductPicker();
      if(state.selectedDesign){
        $('skt-fdp-preview').classList.add('active');
        document.body.style.overflow='hidden';
      }
    }
  }

  function renderPicker(){
    if(state.pickerMode==='collections'){renderCollectionCards();}
    else {renderProductsForCollection('');}
  }

  function renderCollectionCards(){
    var grid=$('skt-fdp-prod-grid');
    var title=$('skt-fdp-prod-title');
    var sub=$('skt-fdp-prod-sub');
    var backLbl=$('skt-fdp-prod-back-label');
    var searchWrap=$('skt-fdp-prod-search-wrap');
    if(title)title.textContent='Choose a Category';
    if(sub)sub.textContent='Pick a category to see available products';
    if(backLbl)backLbl.textContent='Back';
    if(searchWrap)searchWrap.style.display='none';
    if(!grid)return;
    var cols=(data.collections||[]);
    if(cols.length===0){
      grid.innerHTML='<div style="grid-column:1/-1;text-align:center;padding:30px 16px;color:#6B7280;font-size:13px;">No collections available.</div>';
      return;
    }
    var html='';
    cols.forEach(function(col){
      var count=(col.products||[]).length;
      html+='<button type="button" class="skt-fdp-coll-tile" data-coll-handle="'+escAttr(col.handle)+'">'+
        '<div class="skt-fdp-coll-tile__emoji">'+esc(col.emoji||'👕')+'</div>'+
        '<div class="skt-fdp-coll-tile__name">'+esc(col.name)+'</div>'+
        '<div class="skt-fdp-coll-tile__count">'+count+' product'+(count!==1?'s':'')+'</div>'+
      '</button>';
    });
    grid.innerHTML=html;
  }

  function renderProductsForCollection(searchTerm){
    var grid=$('skt-fdp-prod-grid');
    var title=$('skt-fdp-prod-title');
    var sub=$('skt-fdp-prod-sub');
    var backLbl=$('skt-fdp-prod-back-label');
    var searchWrap=$('skt-fdp-prod-search-wrap');
    if(searchWrap)searchWrap.style.display='block';
    if(backLbl)backLbl.textContent='Categories';
    if(!grid)return;
    var col=(data.collections||[]).find(function(c){return c.handle===state.activeCollectionHandle;});
    if(title)title.textContent=col?'Choose a '+col.name+' Product':'Choose a Product';
    if(sub)sub.textContent='Pick the product you want and your design will be pre-loaded';
    var products=(col&&col.products)?col.products.slice():[];
    if(searchTerm){
      var q=searchTerm.toLowerCase().trim();
      products=products.filter(function(p){return(p.title||'').toLowerCase().indexOf(q)>-1;});
    }
    if(products.length===0){
      grid.innerHTML='<div style="grid-column:1/-1;text-align:center;padding:30px 16px;color:#6B7280;font-size:13px;">No products in this category yet.</div>';
      return;
    }
    var designHandle=state.selectedDesign?state.selectedDesign.handle:'';
    var html='';
    products.forEach(function(p){
      var url=p.url+(p.url.indexOf('?')>-1?'&':'?')+'design='+encodeURIComponent(designHandle);
      var img=p.featured_image||'';
      var availClass=p.available?'':' skt-fdp-prod-tile--unavail';
      html+='<a class="skt-fdp-prod-tile'+availClass+'" href="'+escAttr(url)+'">'+
        (img?'<img class="skt-fdp-prod-tile__img" src="'+escAttr(img)+'" alt="'+escAttr(p.title)+'" loading="lazy">':'<div class="skt-fdp-prod-tile__img skt-fdp-prod-tile__img--placeholder">👕</div>')+
        '<div class="skt-fdp-prod-tile__body">'+
          '<div class="skt-fdp-prod-tile__title">'+esc(p.title)+'</div>'+
          '<div class="skt-fdp-prod-tile__price">'+esc(p.price_formatted||'')+'</div>'+
          (p.available?'':'<div class="skt-fdp-prod-tile__unavailable">Out of stock</div>')+
        '</div>'+
      '</a>';
    });
    grid.innerHTML=html;
  }

  function bindEvents(){
    var catsScroll=$('skt-fdp-cats-scroll');
    if(catsScroll){
      catsScroll.addEventListener('click',function(e){
        var card=e.target.closest('.skt-fdp__cat-card');
        if(!card)return;
        var catIdRaw=card.getAttribute('data-cat-id');
        if(catIdRaw==='all'){state.activeCatId='all';}
        else{state.activeCatId=parseInt(catIdRaw,10)||catIdRaw;}
        renderCategoryStrip();
        renderGrid();
        var hd=document.querySelector('.skt-fdp__grid-section .skt-fdp__section-hd');
        if(hd)hd.scrollIntoView({behavior:'smooth',block:'start'});
      });
    }
    var leftArrow=$('skt-fdp-cats-left');
    var rightArrow=$('skt-fdp-cats-right');
    if(leftArrow&&catsScroll)leftArrow.addEventListener('click',function(){catsScroll.scrollBy({left:-300,behavior:'smooth'});});
    if(rightArrow&&catsScroll)rightArrow.addEventListener('click',function(){catsScroll.scrollBy({left:300,behavior:'smooth'});});

    var grid=$('skt-fdp-grid');
    if(grid){
      grid.addEventListener('click',function(e){
        var d=e.target.closest('.skt-fdp__design');
        if(!d)return;
        var idRaw=d.getAttribute('data-design-id');
        var id=parseInt(idRaw,10)||idRaw;
        openPreview(id);
      });
    }

    var search=$('skt-fdp-search');
    if(search){
      var searchTimer=null;
      search.addEventListener('input',function(){
        var v=this.value;
        clearTimeout(searchTimer);
        searchTimer=setTimeout(function(){state.searchTerm=v;renderGrid();},200);
      });
    }

    var pvClose=$('skt-fdp-pv-close');
    var pvCancel=$('skt-fdp-pv-cancel');
    var pvApply=$('skt-fdp-pv-apply');
    var pvModal=$('skt-fdp-preview');
    if(pvClose)pvClose.addEventListener('click',closePreview);
    if(pvCancel)pvCancel.addEventListener('click',closePreview);
    if(pvApply)pvApply.addEventListener('click',openProductPicker);
    if(pvModal)pvModal.addEventListener('click',function(e){if(e.target===this)closePreview();});

    var prodClose=$('skt-fdp-prod-close');
    var prodBack=$('skt-fdp-prod-back');
    var prodModal=$('skt-fdp-products');
    if(prodClose)prodClose.addEventListener('click',closeProductPicker);
    if(prodBack)prodBack.addEventListener('click',backFromPicker);
    if(prodModal)prodModal.addEventListener('click',function(e){if(e.target===this)closeProductPicker();});

    var prodGrid=$('skt-fdp-prod-grid');
    if(prodGrid){
      prodGrid.addEventListener('click',function(e){
        var collTile=e.target.closest('.skt-fdp-coll-tile');
        if(!collTile)return;
        var handle=collTile.getAttribute('data-coll-handle');
        state.activeCollectionHandle=handle;
        state.pickerMode='products';
        renderProductsForCollection('');
        var srch=$('skt-fdp-prod-search');
        if(srch)srch.value='';
      });
    }

    var prodSearch=$('skt-fdp-prod-search');
    if(prodSearch){
      var prodSearchTimer=null;
      prodSearch.addEventListener('input',function(){
        var v=this.value;
        clearTimeout(prodSearchTimer);
        prodSearchTimer=setTimeout(function(){renderProductsForCollection(v);},200);
      });
    }

    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'){
        if($('skt-fdp-products')&&$('skt-fdp-products').classList.contains('active')){closeProductPicker();}
        else if($('skt-fdp-preview')&&$('skt-fdp-preview').classList.contains('active')){closePreview();}
      }
    });
  }

  function init(){
    renderCategoryStrip();
    renderGrid();
    bindEvents();
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else {init();}

})();